import { modifiers, helpers, elements } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import meta from '#utilities/js/ea/meta.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import { dateUserFormat } from '#components/generics/js/datetime/tools.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import href from '#utilities/js/ea/href.js'
import * as nav from './nav.js'

const { parseInt } = Number

export const setTargetValue = (
  container,
  day
) => {
  const { ownerDocument, dataset } = container
  const { targetName } = dataset
  const hdnDay = one(`input[name='${targetName}_day']`, ownerDocument)
  const textDay = one(`input[name='${targetName}_day_text']`, ownerDocument)

  container.dataset.currentDay = day
  container.dataset.activeDay = day.toString()

  if (hdnDay) {
    hdnDay.value = day
  }

  if (textDay) {
    textDay.value = dateUserFormat(ownerDocument, day)
  }
}

export const setCurrentDay = (
  container,
  date
) => {
  const value = Math.round(date.getTime() / 86400 / 1000)
  container.dataset.currentDay = value.toString()
}

const caseToggleView = object(null, {
  days: (container) => {
    return container.dataset.view = 'months'
  },
  months: (container) => {
    return container.dataset.view = 'years'
  },
  years: (container) => {
    return container.dataset.view = 'days'
  }
})

export const toggleView = (
  container,
  forceView = null
) => {
  const nav = one(`.${helpers.dateSelector.elements.nav}`, container)
  const navMonths = one(`.${helpers.dateSelector.elements.nav_months}`, container)
  const navYears = one(`.${helpers.dateSelector.elements.nav_years}`, container)
  const navYearText = one(`.${helpers.dateSelector.elements.nav_years_text}`, container)

  if (forceView) {
    container.dataset.view = forceView
  }

  const view = caseToggleView[container.dataset.view](container)

  if (nav) {
    navMonths?.classList.add(utilities.modifiers.display.none)
    navYears?.classList.add(utilities.modifiers.display.none)
    navYearText?.classList.add(utilities.modifiers.display.none)

    if (view === 'years') {
      navYearText?.classList.remove(utilities.modifiers.display.none)
    } else if (view === 'months') {
      navYears?.classList.remove(utilities.modifiers.display.none)
    } else if (view === 'days') {
      navMonths?.classList.remove(utilities.modifiers.display.none)
    }
  }

  const weekContainer = one(`.${helpers.dateSelector.elements.weekdays}`, container)
  const daysContainer = one(`.${helpers.dateSelector.elements.days}`, container)
  const monthsContainer = one(`.${helpers.dateSelector.elements.months}`, container)
  const yearsContainer = one(`.${helpers.dateSelector.elements.years}`, container)

  if (view === 'months' || (view === 'years')) {
    weekContainer.classList.add(utilities.modifiers.display.none)
    daysContainer.classList.add(utilities.modifiers.display.none)

    if (view === 'months') {
      monthsContainer.classList.remove(utilities.modifiers.display.none)
      yearsContainer?.classList.add(utilities.modifiers.display.none)
    } else if (view === 'years') {
      monthsContainer.classList.add(utilities.modifiers.display.none)
      yearsContainer.classList.remove(utilities.modifiers.display.none)
    }
  } else {
    weekContainer.classList.remove(utilities.modifiers.display.none)
    daysContainer.classList.remove(utilities.modifiers.display.none)
    monthsContainer.classList.add(utilities.modifiers.display.none)
    yearsContainer?.classList.add(utilities.modifiers.display.none)
  }
}

export const setNav = (
  container,
  date
) => {
  const { ownerDocument, dataset } = container
  const { view, min, max } = dataset
  const { documentElement } = ownerDocument
  const { lang } = documentElement
  const nav = one(`.${helpers.dateSelector.elements.nav}`, container)
  const prev = one(`button[name="prev"][data-contract~='date.selector.nav']`, nav)
  const next = one(`button[name="next"][data-contract~='date.selector.nav']`, nav)
  const prevText = one(`.${elements.button_text}`, prev)
  const nextText = one(`.${elements.button_text}`, next)
  const prevJson = scope(prev)
  const nextJson = scope(next)

  if (nav) {
    const minDate = new Date(min * 86400 * 1000)
    const maxDate = new Date(max * 86400 * 1000)
    const minDateYear = minDate.getFullYear()
    const maxDateYear = maxDate.getFullYear()
    const navMonths = one(`.${helpers.dateSelector.elements.nav_months}`, container)
    const navYears = one(`.${helpers.dateSelector.elements.nav_years}`, container)
    const navYearsRange = one(`.${helpers.dateSelector.elements.nav_years_range}`, container)
    const navYearsLabel = one(`.${elements.button_text}`, navYears)
    const navMonthsLabel = one(`.${elements.button_text}`, navMonths)
    const navYearsText = one(`.${helpers.dateSelector.elements.nav_text}`, container)
    const year = date.getFullYear()

    if (prev && next) {
      prev.classList.remove(helpers.dateSelector.modifiers.nav_button.disabled)
      prev.removeAttribute('disabled')
      next.classList.remove(helpers.dateSelector.modifiers.nav_button.disabled)
      next.removeAttribute('disabled')
    }

    if (view === 'days') {
      const month = parseInt(date.getFullYear() + ('0' + date.getMonth()).slice(-2), 10)
      const monthMin = parseInt(minDate.getFullYear() + ('0' + minDate.getMonth()).slice(-2), 10)
      const monthMax = parseInt(maxDate.getFullYear() + ('0' + maxDate.getMonth()).slice(-2), 10)

      navMonthsLabel.textContent = new Intl.DateTimeFormat(lang, {
        month: 'long',
        year: 'numeric'
      }).format(date)
      navMonths.classList.remove(utilities.modifiers.display.none)
      navYears.classList.add(utilities.modifiers.display.none)
      navYearsRange?.classList.add(utilities.modifiers.display.none)

      if (prev && next) {
        prev.title = prevText.textContent = prevJson.text.days
        next.title = nextText.textContent = nextJson.text.days

        if (monthMin === month) {
          prev.classList.add(helpers.dateSelector.modifiers.nav_button.disabled)
          prev.setAttribute('disabled', '')
        }

        if (monthMax === month) {
          next.classList.add(helpers.dateSelector.modifiers.nav_button.disabled)
          next.setAttribute('disabled', '')
        }
      }
    } else if (view === 'months') {
      const yearMin = minDate.getFullYear()
      const yearMax = maxDate.getFullYear()

      if (navYearsLabel) {
        navYearsLabel.textContent = year
      } else {
        navYearsText.textContent = year
      }

      navMonths.classList.add(utilities.modifiers.display.none)
      navYears.classList.remove(utilities.modifiers.display.none)
      navYearsRange?.classList.add(utilities.modifiers.display.none)

      if (prev && next) {
        prev.title = prevText.textContent = prevJson.text.months
        next.title = nextText.textContent = nextJson.text.months

        if (yearMin === year) {
          prev.classList.add(helpers.dateSelector.modifiers.nav_button.disabled)
          prev.setAttribute('disabled', '')
        }

        if (yearMax === year) {
          next.classList.add(helpers.dateSelector.modifiers.nav_button.disabled)
          next.setAttribute('disabled', '')
        }
      }
    } else if (view === 'years') {
      const yearsContainer = one(`.${helpers.dateSelector.elements.years}`, container)
      const buttonYearStart = one(`.${elements.button}`, yearsContainer)
      const buttonYearEnd = one(`.${elements.button}:last-child`, yearsContainer)

      navYearsText.textContent = buttonYearStart.value + ' - ' + buttonYearEnd.value
      navMonths.classList.add(utilities.modifiers.display.none)
      navYears.classList.add(utilities.modifiers.display.none)
      navYearsRange.classList.remove(utilities.modifiers.display.none)

      if (prev && next) {
        prev.title = prevText.textContent = prevJson.text.years
        next.title = nextText.textContent = nextJson.text.years

        if (minDateYear && minDateYear >= buttonYearStart.value) {
          prev.classList.add(helpers.dateSelector.modifiers.nav_button.disabled)
          prev.setAttribute('disabled', '')
        }

        if (maxDateYear && maxDateYear <= buttonYearEnd.value) {
          next.classList.add(helpers.dateSelector.modifiers.nav_button.disabled)
          next.setAttribute('disabled', '')
        }
      }
    }
  }
}

export const setDay = (
  container,
  idx,
  date,
  isPrevious,
  isNext
) => {
  const action = one(`.${helpers.dateSelector.elements.days} .${elements.button}[data-target="day_${idx}"]`, container)
  const { ownerDocument, dataset } = container
  const { min, max, today, activeDay } = dataset
  const { documentElement } = ownerDocument
  const { lang } = documentElement
  const day = Math.round(date.getTime() / 86400 / 1000)
  const now = Math.round(today)

  if (action) {
    const label = one(`.${elements.button_text}`, action)
    const { value, href: hrefAction, dataset } = action
    const { target } = dataset

    if (target === 'day_20') {
      nav.setDay20(action, day)
    }

    if (value) {
      action.value = day
    } else if (hrefAction) {
      action.href = href('calendar/view', {
        'day': day,
      })
    }

    label.textContent = date.getDate()
    action.classList.remove(modifiers.button.is_primary)
    action.classList.remove(modifiers.button.is_secondary)
    action.classList.remove(helpers.dateSelector.elements.disabled)
    action.disabled = false
    action.dataset.scopeJson = JSON.stringify({ dayValue: day })
    action.setAttribute('aria-label', new Intl.DateTimeFormat(lang, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date))

    if (day < min) {
      action.classList.add(helpers.dateSelector.elements.disabled)

      if (hrefAction) {
        action.href = 'javascript:;'
      } else {
        action.disabled = true
      }
    }

    if (day > max) {
      action.classList.add(helpers.dateSelector.elements.disabled)

      if (hrefAction) {
        action.href = 'javascript:;'
      } else {
        action.disabled = true
      }
    }

    if (day < now) {
      action.classList.remove(helpers.dateSelector.modifiers.day.today)
    } else if (day > now) {
      action.classList.remove(helpers.dateSelector.modifiers.day.today)
      action.classList.remove(modifiers.button.is_secondary)
      action.classList.add(modifiers.button.is_outline)
    } else {
      action.classList.remove(modifiers.button.is_outline)
      action.classList.add(helpers.dateSelector.modifiers.day.today)
      action.classList.add(modifiers.button.is_secondary)
    }

    if (activeDay && day === parseInt(activeDay, 10)) {
      action.classList.remove(modifiers.button.is_secondary)
      action.classList.remove(modifiers.button.is_outline)
      action.classList.add(modifiers.button.is_primary)
    }

    if (isPrevious) {
      action.classList.add(helpers.dateSelector.elements.day_previous_month)
    } else {
      action.classList.remove(helpers.dateSelector.elements.day_previous_month)
    }

    if (isNext) {
      action.classList.add(helpers.dateSelector.elements.day_next_month)
    } else {
      action.classList.remove(helpers.dateSelector.elements.day_next_month)
    }
  }
}

export const setDays = (
  container,
  date
) => {
  const { dataset } = container
  const { dateWeek } = dataset
  const lastDayPreviousMonthDate = new Date(date.getFullYear(), date.getMonth(), 0)
  const lastDayPreviousMonth = lastDayPreviousMonthDate.getDay()
  const lastDayMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  const days = lastDayMonthDate.getDate()
  let dateWeekAdd = 1
  let day

  setNav(container, date)

  if (dateWeek === '7') {
    dateWeekAdd = 0
  }

  for (let i = 0; i < 42; i += 1) {
    day = new Date(date.getTime())
    day.setDate(i - lastDayPreviousMonth + dateWeekAdd)

    setDay(container, i, day, Boolean((i - lastDayPreviousMonth) < 0), Boolean(i > (lastDayPreviousMonth + days - 1)))
  }
}

export const setMonth = (
  container,
  idx
) => {
  const button = one(`button[name="month_${idx}"].${helpers.dateSelector.elements.month}`, container)
  const { dataset } = container
  const { min, max, currentDay, today, activeDay } = dataset

  if (button) {
    const todayYear = new Date(parseInt(today, 10) * 86400 * 1000).getFullYear()
    const todayMonth = new Date(parseInt(today, 10) * 86400 * 1000).getMonth() + 1
    const currentDate = new Date(parseInt(currentDay, 10) * 86400 * 1000)
    const currentYear = currentDate.getFullYear()
    const minDate = new Date(parseInt(min, 10) * 86400 * 1000)
    const maxDate = new Date(parseInt(max, 10) * 86400 * 1000)
    const minYearMonth = minDate.getFullYear() * 100 + (minDate.getMonth() + 1)
    const maxYearMonth = maxDate.getFullYear() * 100 + (maxDate.getMonth() + 1)
    const buttonDate = new Date(currentYear, idx - 1, 20)
    const buttonYearMonth = buttonDate.getFullYear() * 100 + (buttonDate.getMonth() + 1)

    button.value = Math.round((buttonDate.getTime() / 86400 / 1000))
    button.classList.remove(modifiers.button.is_primary)
    button.classList.remove(modifiers.button.is_secondary)
    button.classList.remove(helpers.dateSelector.elements.disabled)
    button.classList.add(modifiers.button.is_outline)
    button.disabled = false

    if (buttonYearMonth < minYearMonth || buttonYearMonth > maxYearMonth) {
      button.classList.add(helpers.dateSelector.elements.disabled)
      button.disabled = true
    }

    if (todayYear === currentYear && todayMonth === idx) {
      button.classList.remove(modifiers.button.is_outline)
      button.classList.add(modifiers.button.is_secondary)
    }

    if (activeDay) {
      const activeDate = new Date(parseInt(activeDay, 10) * 86400 * 1000)
      const activeYear = activeDate.getFullYear()
      const activeMonth = activeDate.getMonth() + 1

      if (activeDay && buttonDate.getFullYear() === activeYear && idx === activeMonth) {
        button.classList.remove(modifiers.button.is_outline)
        button.classList.remove(modifiers.button.is_secondary)
        button.classList.add(modifiers.button.is_primary)
      }
    }
  }
}

export const setMonths = (
  container,
  date
) => {
  setNav(container, date)

  for (let i = 1; i <= 12; i += 1) {
    setMonth(container, i)
  }
}

export const setYear = (
  container,
  idx,
  year,
  yearMin,
  yearMax
) => {
  const { dataset } = container
  const { today, activeDay } = dataset
  const yearsContainer = one(`.${helpers.dateSelector.elements.years}`, container)
  const button = one(`.${elements.button}[data-target="year_${idx}"]`, yearsContainer)
  const buttonText = one(`.${elements.button_text}`, button)
  const yearNow = new Date(parseInt(today, 10) * 86400 * 1000).getFullYear()

  if (button) {
    button.classList.remove(helpers.dateSelector.elements.disabled)
    button.classList.remove(helpers.dateSelector.modifiers.year.now)
    button.classList.remove(modifiers.button.is_primary)
    button.classList.remove(modifiers.button.is_secondary)
    button.classList.add(modifiers.button.is_outline)
    button.disabled = false
    button.value = year
    button.name = 'year_' + year
    button.setAttribute('data-target', 'year_' + idx)
    buttonText.textContent = year

    if (year === yearNow) {
      button.classList.remove(modifiers.button.is_outline)
      button.classList.add(helpers.dateSelector.modifiers.year.now)
      button.classList.add(modifiers.button.is_secondary)
    }

    if (activeDay) {
      const activeDate = new Date(parseInt(activeDay, 10) * 86400 * 1000)
      const activeYear = activeDate.getFullYear()

      if (year === activeYear) {
        button.classList.remove(modifiers.button.is_outline)
        button.classList.remove(modifiers.button.is_secondary)
        button.classList.add(modifiers.button.is_primary)
      }
    }

    if (year < yearMin || year > yearMax) {
      button.classList.add(helpers.dateSelector.elements.disabled)
      button.disabled = true
    }
  }
}

export const setYears = (
  container,
  yearStart
) => {
  const { dataset } = container
  const { min, max, currentDay } = dataset
  const currentDate = new Date(parseInt(currentDay, 10) * 86400 * 1000)
  const year = currentDate.getFullYear()
  const yearMin = new Date(parseInt(min, 10) * 86400 * 1000).getFullYear()
  const yearMax = new Date(parseInt(max, 10) * 86400 * 1000).getFullYear()
  const yearsDisplayNb = 24
  let yearsDisplayMin = year - yearsDisplayNb / 2 + 1
  let yearsDisplayMax = year + yearsDisplayNb / 2
  let idx = 0

  if (yearStart) {
    yearsDisplayMin = yearStart.getFullYear()
  } else {
    if (yearMin && yearMax) {
      const availableYearsNb = yearMax - yearMin + 1

      if (availableYearsNb >= yearsDisplayNb) { // = à vérifier
        if (yearMin > yearsDisplayMin) {
          yearsDisplayMin = yearMin
        }
        if (yearMax < yearsDisplayMax) {
          const diff = yearsDisplayMax - yearMax
          yearsDisplayMin -= diff
        }
      } else {
        yearsDisplayMin = yearMin
      }
    } else if (yearMin) {
      if (yearMin > yearsDisplayMin) {
        yearsDisplayMin = yearMin
      }
    } else if (yearMax) {
      if (yearMax < yearsDisplayMax) {
        const diff = yearsDisplayMax - yearMax
        yearsDisplayMin -= diff
      }
    }
  }

  for (let y = yearsDisplayMin; y <= yearsDisplayMin + yearsDisplayNb - 1; y += 1) {
    setYear(container, idx, y, yearMin, yearMax)
    idx += 1
  }

  setNav(container, currentDate)
}
